<template>
  <div id="ExtensionPopup">
    <div class="top">
      <div class="print" @click="printComponent()">Print</div>
    </div>
    <div id="invoice">
      <div class="header">
        <img src="@/assets/broncos-logo.svg" />
        <h1>AMENDMENT TO CLUB SEAT LICENSE AGREEMENT</h1>
        <h2>
          LICENSEE: <span>{{ global.userInfo.fullName }}</span> // ACCOUNT
          NUMBER: <span>{{ global.userInfo.Account }}</span>
        </h2>
      </div>
      <div class="intro">
        <p>
          For good and valuable consideration, the receipt and sufﬁciency of which is hereby acknowledged, Stadium Management Company, LLC ("Licensor") and Licensee (designated below) hereby agree to amend (this “Amendment”) the Club Seat License Agreement, referring to and including the "Cover Page" (front and back), the pamphlet entitled "Stadium Management Company Club Seat License Agreement, Terms and Conditions and Club Seat Pricing Schedule," and any prior or subsequent amendments thereto (hereinafter, collectively, the "Agreement") as follows:
        </p>
      </div>
      <div class="terms">
        <h3>ADDITIONAL TERM OF THE AGREEMENT</h3>
        <h4>
          Select Agreement Term
        </h4>
        <br />
        <div class="ta-button-cnt">
          <div class="ta-button">
            <label for="two-year-term">2-Year License Term</label>
            <input type="radio" v-model="agreementTerm" name="agreementTerm" value="two-year-term" :checked="agreementTermChecked == 'two-year-term'"/>
          </div>
          <div class="ta-button">
            <label for="four-year-term">4-Year License Term</label>
            <input type="radio" v-model="agreementTerm" name="agreementTerm" value="four-year-term" :checked="agreementTermChecked == 'four-year-term'"/>
          </div>
          <div class="ta-button">
            <label for="four-year-term">6-Year License Term</label>
            <input type="radio" v-model="agreementTerm" name="agreementTerm" value="six-year-term" :checked="agreementTermChecked == 'six-year-term'"/>
          </div>
        </div>
      </div>
      <div class="fees">
        <h3>CLUB SEAT ANNUAL LICENSE FEE</h3>
        <p>
          Under the Agreement, Licensee is required to pay an Annual License Fee, which for purposes of this Amendment includes the Ticket Price Adjustment as set forth in the Agreement. In partial consideration of Licensee's Renewal of the term of the Agreement as set forth above, Licensor hereby agrees that the Annual License Fee payable during the Renewal Term shall be in the amounts set forth in the chart attached below, and during the Renewal Term the Annual License Fees shall not be subject to the Ticket Price Adjustment set forth in the Agreement.
          <br /><br />
          The Annual License Fee and Ticket Price Adjustment for any additional term of the Agreement following the Renewal Term shall be subject to Licensor's then current pricing schedules and policies, or as may be determined by Licensor at that time in its sole discretion, unless otherwise or further agreed to by the parties pursuant to a written amendment to the Agreement.
        </p>
        <h3 class="second">TERMS AND CONDITIONS</h3>
        <p>
          Licensee acknowledges and agrees to the terms of the pamphlet entitled "Stadium Management Company Club Seat License Agreement, Terms and Conditions and Club Seat Pricing Schedule" in existence as of the date hereof, a copy of which is being provided to Licensee with this Amendment (the “Updated Pamphlet”).  The Updated Pamphlet supersedes in its entirety and controls over any previously provided Pamphlet relating to the Agreement.
          <br /><br />
          The Agreement is hereby amended only as expressly set forth above in the printed format; all other provisions of the Agreement shall remain in full force and effect. The Agreement, together with this Amendment, constitute the entire agreement of the parties with respect to the Club Seat Account identiﬁed above and supersedes all prior negotiations, representations and agreements by or between the parties hereto.
          <br /><br />
          Upon execution of this Amendment by Licensee by electronic means as set forth below, Licensor agrees to be bound by the terms of the Agreement and this Amendment.
          <br /><br />
          <a href="https://broncos.vipfanportal.com/2025/pdf/Club-Seat-License-Agreement-Amendment-to-Renew-Term-2024-Expiring-Contracts.pdf" target="_blank">Click here</a> to download the Agreement.
        </p>
        <h2>
          <!-- <span>{{ global.userInfo.zoneType }} ZONE</span> -->
          <br />
          Annual United Club ticket price (per seat)
        </h2>
        <div class="pricing">
          <div class="pricing__row titleRow">
            <div class="cell year">Year</div>
            <div class="cell content">2-YR Term</div>
            <div class="cell content">4-YR Term</div>
            <div class="cell content">6-YR Term</div>
          </div>
          <div class="pricing__row contentRow">
            <div class="cell year">2026</div>
            <div class="cell content">{{ global.userInfo.twoYear2026 }}</div>
            <div class="cell content">{{ global.userInfo.fourYear2026 }}</div>
            <div class="cell content">{{ global.userInfo.sixYear2026 }}</div>
          </div>
          <div class="pricing__row contentRow">
            <div class="cell year">2027</div>
            <div class="cell content">{{ global.userInfo.twoYear2027 }}</div>
            <div class="cell content">{{ global.userInfo.fourYear2027 }}</div>
            <div class="cell content">{{ global.userInfo.sixYear2027 }}</div>
          </div>
          <div class="pricing__row contentRow">
            <div class="cell year">2028</div>
            <div class="cell content">EXPIRED</div>
            <div class="cell content">{{ global.userInfo.fourYear2028 }}</div>
            <div class="cell content">{{ global.userInfo.sixYear2028 }}</div>
          </div>
          <div class="pricing__row contentRow">
            <div class="cell year">2029</div>
            <div class="cell content">&nbsp;</div>
            <div class="cell content">{{ global.userInfo.fourYear2029 }}</div>
            <div class="cell content">{{ global.userInfo.sixYear2029 }}</div>
          </div>
          <div class="pricing__row contentRow">
            <div class="cell year">2030</div>
            <div class="cell content">&nbsp;</div>
            <div class="cell content">EXPIRED</div>
            <div class="cell content">{{ global.userInfo.sixYear2030 }}</div>
          </div>
          <div class="pricing__row contentRow">
            <div class="cell year">2031</div>
            <div class="cell content">&nbsp;</div>
            <div class="cell content">&nbsp;</div>
            <div class="cell content">{{ global.userInfo.sixYear2031 }}</div>
          </div>
          <div class="pricing__row contentRow">
            <div class="cell year">2032</div>
            <div class="cell content">&nbsp;</div>
            <div class="cell content">&nbsp;</div>
            <div class="cell content">EXPIRED</div>
          </div>
        </div>
      </div>
      <div class="agreement">
        <h2>
          LICENSEE: <span>{{ global.userInfo.fullName }}</span>
          <br />
          ACCOUNT NUMBER: <span>{{ global.userInfo.Account }}</span>
        </h2>
        <br />
        <h4>ONLINE SIGNATURE*</h4>
        <input
          type="text"
          size="50"
          v-model="signature"
          required
          title="Broncos Fan"
        />
        <p>PLEASE TYPE YOUR FIRST AND LAST NAME</p>
        <h2>DEADLINE TO RENEW: OCTOBER 21, 2025</h2>
        <div class="renewBtn" v-if="!formSubmitted && blank" @click="submitForm()">
          Renew Now
        </div>
        <div class="accepted" v-if="!blank">
          <p>Thank you for renewing your United Club Level season tickets. As a reminder, the first payment for the 2025 season is due by October 21, 2025. Click <a href="https://am.ticketmaster.com/broncos/" target="_blank">here</a> to login to Account Manager to arrange payment.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import axios from "axios";

export default {
  name: "ExtensionPopup",
  computed: {
    ...mapState(["global"]),
  },
  data() {
    return {
      signature: "",
      agreementTerm: "",
      agreementTermChecked: "",
      formSubmitted: false,
      blank: false,
    };
  },
  mounted() {
    setTimeout(() => {
      this.signature = this.global.userInfo.signature;
      if (this.global.userInfo.signature === "") {
        this.blank = true;
      } else {
        this.blank = false;
      }
    }, 1000);
  },
  methods: {
    printComponent() {
      var printContent = document.getElementById("invoice").innerHTML;
      let stylesHtml = "./ExtensionPopup.scss";
      for (const node of [
        ...document.querySelectorAll('link[rel="stylesheet"], style'),
      ]) {
        stylesHtml += node.outerHtml;
      }

      const WinPrint = window.open(
        "",
        "",
        "left=0,top=0,width=900,toolbar=0,scrollbars=0,status=0"
      );

      WinPrint.document.write(`<!DOCTYPE html>
      <html>
        <head>
          ${stylesHtml}
        </head>
        <body>
          ${printContent}
        </body>
      </html>`);

      WinPrint.document.close();
      WinPrint.focus();
      WinPrint.print();
      WinPrint.close();
    },
    async submitForm() {
      const purl = this.global.userInfo.purl;
      const formData = {
        signature: this.signature,
        timeOfSignature: new Date(),
        agreementTerm: this.agreementTerm,
      };
      if (!purl) return;
      if (this.agreementTerm.length < 2) {
        alert("Please select an agreement term");
        return;
      }
      if (this.signature.length < 5) {
        alert("Please enter signature");
        return;
      }

      this.formSubmitted = true;

      try {
        const response = await axios.post(
          process.env.VUE_APP_BASE_URL + "/api/router/Forms.php",
          {
            action: "submitSurvey",
            prefix: "broncos2025extension",
            formValues: formData,
            accountId: this.global.userInfo.Account,
            purl: this.global.userInfo.purl,
            fullName: this.global.userInfo.fullName,
            repName: this.global.userInfo.repName,
            repEmail: this.global.userInfo.repEmail,
            firstSeat: this.global.userInfo.firstSeat,
            lastSeat: this.global.userInfo.lastSeat,
            timestamp: new Date(),
          }
        );

  
        if (response.status === 200) {
          alert("Thank you for submitting your extension agreement and for the continued support of the Denver Broncos. You will be invoiced following the 2025 season to arrange payment for 2026.");
          this.formSubmitted = true;
        } else {
          this.formSubmitted = false;
        }
      } catch (error) {
        console.error("Submission failed:", error);
        alert("There was a problem submitting the form. Please try again.");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#ExtensionPopup {
  width: 100%;
  max-width: 940px;
  background-color: #fff;
  margin: 0;
  h1 {
    font-family: AvenirNextCondensed-Bold;
    font-size: 24px;
    line-height: 30px;
    color: #f26522;
    padding: 0 50px;
    margin-top: 15px;
  }
  h2 {
    font-family: AvenirNextCondensed-Bold;
    font-size: 20px;
    line-height: 30px;
    color: #666;
    text-align: center;
    padding: 0 50px;
    span {
      font-family: AvenirNextCondensed-Medium;
    }
  }
  h3 {
    font-family: AvenirNextCondensed-Bold;
    font-size: 20px;
    line-height: 50px;
    text-align: center;
    color: #061632;
    border-top: 1px solid #061632;
    border-bottom: 1px solid #061632;
    margin-bottom: 25px;
    background: #ccc;
    padding: 0 50px;
    width: 100%;
    @media (max-width: $md) {
      line-height: 24px;
    }
  }
  h4 {
    font-family: AvenirNextCondensed-Bold;
    font-size: 20px;
    line-height: 28px;
    color: #000;
    text-align: center;
    padding: 0 50px;
  }
  p {
    font-family: AvenirNextCondensed-Medium;
    font-size: 14px;
    line-height: 18px;
    color: #000;
    padding: 0 50px;
  }

  .top {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50px;
    width: 100%;
    background: #f26522;
    .print {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 130px;
      padding: 5px;
      font-family: AvenirNextCondensed-Bold;
      font-family: 20px;
      line-height: 20px;
      text-transform: uppercase;
      color: #061632;
      border: 2px solid #061632;
      background: #fff;
      cursor: pointer;
    }
  }
  #invoice {
    display: flex;
    flex-direction: column;
    .header {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 50px 0;
      width: 100%;
      border-bottom: 1px solid #000;
      @media (max-width: $md) {
        padding: 25px 0;
      }
      img {
        height: 73px;
        object-fit: contain;
      }
      h2 {
        text-transform: uppercase;
      }
    }
    .intro {
      padding: 25px 0 15px 0;
    }
    .terms {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-bottom: 15px;
      .ta-button-cnt {
        position: relative;
        display: flex;
        justify-content: center;
        .ta-button {
          position: relative;
          display: inline-flex;
          margin: 5px;
          input[type=radio] {
            cursor: pointer;
            position: relative;
            padding: 10px;
            width: 218px;
            height: 37px;
            background: #D1D1D1;
            -webkit-appearance: none;
            outline: none;
          }
          input[type=radio]:checked {
            background: #F26522;
          }
          label {
            z-index: 1;
            pointer-events: none;
            position: absolute;
            display: block;
            left: 50%;
            top: 50%;
            width: 100%;
            margin: 0;
            text-align: center;
            font-size: 16px;
            font-family: AvenirNextCondensed-BoldItalic;
            line-height: 15px;
            text-transform: uppercase;
            color: #000;
            transform: translate(-50%, -50%);
            -ms-transform: translate(-50%, -50%);
          }
        }
      }
      @media (max-width: $sm) {
        .ta-button-cnt {
          flex-direction: column;
        }
        .ta-note {
          text-align: center;
        }
      }
    }
    .fees {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-bottom: 25px;
      h2 {
        margin-top: 15px;
        padding: 0 50px;
        span {
          font-family: AvenirNextCondensed-Medium;
          color: #f26522;
        }
      }
      p {
        a {
          text-decoration: none;
          color: #f26522;
        }
      }
      .second {
        margin-top: 15px;
      }
      .pricing {
        display: flex;
        flex-direction: column;
        width: 100%;
        max-width: 600px;
        padding: 0 50px;
        margin-top: 20px;
        &__row {
          display: flex;
          flex-direction: row;
          width: 100%;
          padding-left: 10px;
          &.titleRow {
            border-bottom: 1px solid #061632;
            background: #ccc;
            font-family: AvenirNextCondensed-Bold;
            font-size: 16px;
            line-height: 20px;
            white-space: nowrap;
            color: #061632;
            text-transform: uppercase;
          }
          &.contentRow {
            .year {
              font-family: AvenirNextCondensed-Bold;
              font-size: 16px;
              color: #061632;
              font-size: 16px;
              line-height: 20px;
              white-space: nowrap;
            }
            .content {
              font-family: AvenirNextCondensed-Medium;
              font-size: 16px;
              line-height: 20px;
              color: #f26522;
              white-space: nowrap;
              text-align: center;
            }
          }
          .cell {
            padding: 10px 0;
            text-align: center;
            &.year {
              flex: 1;
            }
            &.content {
              flex: 2;
            }
          }
        }
        @media (max-width: $md) {
          padding: 0 20px;
        }
      }
    }
    .agreement {
      display: flex;
      flex-direction: column;
      align-items: center;
      // padding-bottom: 25px;
      padding: 0 20px 25px;
      h2 {
        span {
          color: #f26522;
        }
      }
      input {
        font-family: "MarketWeb";
        font-weight: 700;
        font-style: normal;
        width: 100%;
        max-width: 350px;
        height: 50px;
        font-size: 24px;
        line-height: 50px;
        text-align: center;
        color: #061632;
        border: 0;
        border-bottom: 1px solid #000;
        background-color: rgba(239, 239, 239, 0.5);
        margin: 0 0 10px 0;
        outline: none;
      }
      p {
        margin-bottom: 15px;
      }
      .renewBtn {
        font-family: AvenirNextCondensed-Bold;
        font-size: 20px;
        line-height: 20px;
        text-align: center;
        text-transform: uppercase;
        color: #061632;
        background: #f26522;
        border: 2px solid #061632;
        margin: 10px auto;
        padding: 10px;
        width: 150px;
        cursor: pointer;
        &.grey {
          background: #ccc;
          cursor: default;
        }
      }
      .accepted {
        max-width: 610px;
        font-family: AvenirNextCondensed-Medium;
        font-size: 16px;
        line-height: 30px;
        text-align: center;
        color: #061632;
        a {
          text-decoration: none;
          color: #f26522;
        }
      }
    }
    @media (max-width: $md) {
      text-align: center;
      h1, h2, h3, h4, p {
          padding: 0 20px;
      }
      h3 {
        padding: 20px;
      }
    }
  }
}
</style>